import RegisteredUserView from "../../../jsx/components/Dashboard/BusinessToCustomer/RegisteredUsers/RegisteredUserView";

const RegisteredUserWrapper = () => {
  return <RegisteredUserView />;
};

export const allowedRoles = [_enum.ROUTE_PERSONAS.admin];

export default constore(RegisteredUserWrapper);
